import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=654e1b44&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=654e1b44&prod&lang=less"
import style1 from "./detail.vue?vue&type=style&index=1&id=654e1b44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e1b44",
  null
  
)

export default component.exports